import React from 'react';
import classNames from 'classnames';
import './export-footer.scss';

const ExportFooter = props => {
    return (
        <footer className={classNames({
            'export-footer': true,
            'export-footer--exporting': props.isExporting,
            'export-footer--finished': props.isExportingFinished
        })}>
            {props.btnComponent}
            <button type="button" className="form__button form__button--small" onClick={() => props.print()}>Skriv ut</button>
        </footer>
    );
};

export default ExportFooter;